<template>
  <div class="sf-plan-check-container">
    <!-- ====== 顶部：筛选区域 ====== -->
    <div class="filter-section">
      <el-form :inline="true" size="small" class="filter-form" :model="filterForm">
        <el-form-item label="房屋地址">
          <el-input
            v-model="filterForm.房屋地址"
            placeholder="请输入房屋地址"
            clearable
            style="width:220px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            v-model="filterForm.状态"
            placeholder="请选择状态"
            disabled
            style="width:140px"
          >
            <el-option label="待审核" value="待审核" />
          </el-select>
        </el-form-item>

        <el-form-item label="预计付款日期">
          <el-date-picker
            v-model="filterForm.预计付款日期范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item label="实际付款日期">
          <el-date-picker
            v-model="filterForm.实际付款日期范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ====== 中间：按钮区域 ====== -->
    <div class="button-section">
      <el-button
        type="info"
        size="medium"
        icon="el-icon-view"
        :disabled="!canOperate"
        @click="openCheckDialog"
      >
        审核
      </el-button>
      <el-button
        type="success"
        size="medium"
        icon="el-icon-house"
        :disabled="!canOperate"
        @click="openHouseDetailDialog"
      >
        查看房源信息
      </el-button>
    </div>

    <!-- ====== 下方：表格区域 ====== -->
    <div class="table-section">
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        stripe
        highlight-current-row
        v-loading="loading"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        style="width: 100%"
        max-height="550"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="房东" label="房东" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="房屋地址" label="房屋地址" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="状态" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="getStatusType(row.状态)" size="small">
              {{ row.状态 || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="合同起始日" label="合同起始日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同起始日) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同到期日" label="合同到期日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同到期日) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款日期" label="预计付款日期" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.付款日期) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款金额" label="预计付款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.付款金额 ? `¥${row.付款金额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="支付户名" label="支付户名" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="银行卡号" label="银行卡号" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="开户行" label="开户行" width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="距离付款天数" label="距离付款还有*天" width="140" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.距离付款天数 !== null && row.距离付款天数 !== undefined ? row.距离付款天数 : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="实际付款时间" label="实际付款时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.实际付款时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="实际付款金额" label="实际付款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.实际付款金额 ? `¥${row.实际付款金额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="退回原因" label="退回原因" min-width="150" align="center" show-overflow-tooltip />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          background
        />
      </div>
    </div>

    <!-- ====== 审核弹窗 ====== -->
 
<!-- ====== 审核弹窗 ====== -->
<el-dialog
  title="审核付款计划"
  :visible.sync="checkDialog.visible"
  width="700px"
  :close-on-click-modal="false"
  @close="resetCheckForm"
  class="check-dialog"
  top="10vh"
>
  <div class="check-dialog-content">
    <el-descriptions :column="1" border size="medium" :label-style="{ width: '180px' }">
      <el-descriptions-item label="房屋地址">
        {{ checkData.房屋地址 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="合同起始日">
        {{ formatTimestamp(checkData.合同起始日) }}
      </el-descriptions-item>

      <el-descriptions-item label="合同到期日">
        {{ formatTimestamp(checkData.合同到期日) }}
      </el-descriptions-item>

      <el-descriptions-item label="房东">
        {{ checkData.房东 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="状态">
        <el-tag :type="getStatusType(checkData.状态)" size="small">
          {{ checkData.状态 || '-' }}
        </el-tag>
      </el-descriptions-item>

      <el-descriptions-item label="预计付款日期">
        {{ formatTimestamp(checkData.付款日期) }}
      </el-descriptions-item>

      <el-descriptions-item label="预计付款金额">
        {{ checkData.付款金额 ? `¥${checkData.付款金额}` : '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="第几次付款">
        {{ checkData.第几次付款 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="支付户名">
        {{ checkData.支付户名 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="银行卡号">
        {{ checkData.银行卡号 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="开户行">
        {{ checkData.开户行 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="备注">
        {{ checkData.备注 || '-' }}
      </el-descriptions-item>

      <el-descriptions-item label="实际付款时间">
        {{ formatTimestamp(checkData.实际付款时间) }}
      </el-descriptions-item>

      <el-descriptions-item label="实际付款金额">
        {{ checkData.实际付款金额 ? `¥${checkData.实际付款金额}` : '-' }}
      </el-descriptions-item>

      <el-descriptions-item v-if="checkData.退回原因" label="退回原因">
        {{ checkData.退回原因 }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- ====== 付款凭证（独立小标题） ====== -->
    <div class="file-section">
      <div class="file-section-title">付款凭证</div>
      <div class="file-group-inline">
        <el-table :data="checkFileList" border stripe size="small" v-loading="fileLoading">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix) && (row.show_path_full || row.show_path)" class="preview-thumbnail">
                <el-image
                  :src="row.show_path_full || row.show_path"
                  fit="cover"
                  style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                  :preview-src-list="[row.show_path_full || row.show_path]"
                />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleViewFile(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="checkFileList.length === 0" class="empty-tip-inline">
          暂无付款凭证
        </div>
      </div>
    </div>
  </div>

  <span slot="footer">
    <el-button @click="checkDialog.visible = false">关闭</el-button>
    <el-button type="success" @click="handlePass" :loading="checkDialog.submitting">通过</el-button>
    <el-button type="danger" @click="openRejectDialog" :loading="checkDialog.submitting">驳回</el-button>
  </span>
</el-dialog>
    <!-- ====== 驳回弹窗 ====== -->
    <el-dialog
      title="驳回"
      :visible.sync="rejectDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetRejectForm"
    >
      <el-form :model="rejectForm" label-width="100px" size="small">
        <el-form-item label="退回原因" prop="退回原因" required>
          <el-input
            v-model="rejectForm.退回原因"
            type="textarea"
            :rows="4"
            placeholder="请输入退回原因"
          />
        </el-form-item>
        <el-form-item label="备注" prop="备注">
          <el-input
            v-model="rejectForm.备注"
            type="textarea"
            :rows="2"
            placeholder="请输入备注（可选）"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rejectDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleRejectSubmit" :loading="rejectDialog.submitting">确认驳回</el-button>
      </span>
    </el-dialog>

    <!-- ====== 房源详情弹窗 ====== -->
    <HouseDetailDialog
      :visible.sync="houseDetailDialogVisible"
      :house-id="selectedRows.length === 1 ? selectedRows[0].房源ID : null"
    />
  </div>
</template>

<script>
import { sfPlanApi } from '@/api/付款/sfPlanApi'
import { fileMethod } from '@/api/files/fileMethod'
import HouseDetailDialog from './component/HouseDetailDialog.vue'

export default {
  name: 'MoneySfPlanCheck',

  components: {
    HouseDetailDialog
  },

  data() {
    return {
      // ====== 筛选表单 ======
      filterForm: {
        房屋地址: '',
        状态: '待审核',
        预计付款日期范围: [],
        实际付款日期范围: []
      },

      // ====== 表格数据 ======
      tableData: [],
      loading: false,
      selectedRows: [],

      // ====== 分页 ======
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },

      // ====== 审核弹窗 ======
      checkDialog: {
        visible: false,
        submitting: false,
        rowData: null
      },
      checkData: {},
      checkFileList: [],
      fileLoading: false,

      // ====== 驳回弹窗 ======
      rejectDialog: {
        visible: false,
        submitting: false
      },
      rejectForm: {
        退回原因: '',
        备注: ''
      },

      // ====== 房源详情弹窗 ======
      houseDetailDialogVisible: false
    }
  },

  computed: {
    canOperate() {
      return this.selectedRows.length === 1
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    // ====== 初始化 ======
    init() {
      this.loadData()
    },

    // ====== 后端字段 -> 前端字段映射 ======
    mapFields(data) {
      if (!data) return {}

      const fieldMap = {
        'id': 'id',
        '房源ID': '房源ID',
        '状态': '状态',
        '付款日期': '付款日期',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '银行卡号': '银行卡号',
        '备注': '备注',
        '房东': '房东',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '开户行': '开户行',
        '支付户名': '支付户名',
        '实际付款时间': '实际付款时间',
        '实际付款金额': '实际付款金额',
        '退回原因': '退回原因'
      }

      const result = {}
      for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
        if (data.hasOwnProperty(backendKey)) {
          result[frontendKey] = data[backendKey]
        }
      }

      const timestampFields = ['付款日期', '合同起始日', '合同到期日', '实际付款时间']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      if (result.状态 === '待付' && result.付款日期) {
        const now = new Date().getTime()
        const diffDays = Math.ceil((result.付款日期 - now) / (1000 * 60 * 60 * 24))
        result.距离付款天数 = diffDays
      } else {
        result.距离付款天数 = null
      }

      return result
    },

    // ====== 加载数据 ======
    loadData() {
      this.loading = true

      const params = {
        状态: '待审核',
        pageIndex: this.pageInfo.pageIndex - 1,
        pageSize: this.pageInfo.pageSize
      }

      if (this.filterForm.房屋地址) {
        params.房屋地址 = this.filterForm.房屋地址
      }
      if (this.filterForm.预计付款日期范围 && this.filterForm.预计付款日期范围.length === 2) {
        const [start, end] = this.filterForm.预计付款日期范围
        params.付款时间_start = Math.floor(start / 1000)
        params.付款时间_end = Math.floor(end / 1000)
      }
      if (this.filterForm.实际付款日期范围 && this.filterForm.实际付款日期范围.length === 2) {
        const [start, end] = this.filterForm.实际付款日期范围
        params.实际付款时间_start = Math.floor(start / 1000)
        params.实际付款时间_end = Math.floor(end / 1000)
      }

      console.log('查询待审核付款计划参数===', params)

      sfPlanApi.select(params).then((res) => {
        console.log('返回数据===', res)

        if (res.code === 200) {
          const rawList = res.data?.list || []
          this.tableData = rawList.map(item => this.mapFields(item))
          this.pageInfo.total = res.data?.total || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        console.error('请求失败===', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // ====== 搜索 ======
    handleSearch() {
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    // ====== 重置搜索 ======
    resetSearch() {
      this.filterForm = {
        房屋地址: '',
        状态: '待审核',
        预计付款日期范围: [],
        实际付款日期范围: []
      }
      this.handleSearch()
    },

    // ====== 分页 ======
    handleSizeChange(size) {
      this.pageInfo.pageSize = size
      this.loadData()
    },

    handleCurrentChange(page) {
      this.pageInfo.pageIndex = page
      this.loadData()
    },

    // ====== 表格选择变化 ======
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    // ====== 行点击 ======
    handleRowClick(row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },

    // ====== 双击行 - 打开审核弹窗 ======
    handleRowDblclick(row) {
      this.$refs.tableRef.toggleRowSelection(row)
      this.selectedRows = [row]
      this.openCheckDialog()
    },

    // ====== 打开审核弹窗 ======
    openCheckDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]
      this.checkDialog.rowData = row
      this.checkData = { ...row }
      this.checkDialog.visible = true

      if (row.id) {
        this.loadCheckFiles(row.id)
      }
    },

    // ====== 加载付款凭证 ======
    async loadCheckFiles(recordId) {
      if (!recordId) return

      this.fileLoading = true
      const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'

      try {
        const res = await fileMethod.listFiles('收房付款计划', String(recordId), '付款凭证', null)
        console.log('加载付款凭证返回:', res)

        if (res.code === 200) {
          const list = res.data?.list || []
          this.checkFileList = list.map(item => {
            if (item.show_path) {
              const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
              item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + item.show_path.replace(/^\//, '')
            } else {
              item.show_path_full = ''
            }
            return item
          })
        }
      } catch (error) {
        console.error('加载付款凭证失败:', error)
      } finally {
        this.fileLoading = false
      }
    },

    // ====== 查看文件 ======
    handleViewFile(row) {
      const url = row.show_path_full || row.show_path
      if (url) {
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 重置审核表单 ======
    resetCheckForm() {
      this.checkDialog.submitting = false
      this.checkDialog.rowData = null
      this.checkData = {}
      this.checkFileList = []
    },

    // ====== 通过 ======
    handlePass() {
      const row = this.checkDialog.rowData
      if (!row) return

      this.$confirm(
        '确认通过该付款计划吗？',
        '通过确认',
        {
          type: 'warning',
          confirmButtonText: '确认通过',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        this.checkDialog.submitting = true

        try {
          const params = { id: row.id }
          console.log('通过参数===', params)

          const res = await sfPlanApi.pass(params)
          console.log('通过返回===', res)

          if (res.code === 200) {
            this.$message.success('通过成功！状态已更新为"已付"')
            this.checkDialog.visible = false
            this.loadData()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('通过失败:', error)
          this.$message.error(error.message || '操作失败，请稍后重试')
        } finally {
          this.checkDialog.submitting = false
        }
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    // ====== 打开驳回弹窗 ======
    openRejectDialog() {
      this.rejectForm = {
        退回原因: '',
        备注: ''
      }
      this.rejectDialog.visible = true
    },

    // ====== 重置驳回表单 ======
    resetRejectForm() {
      this.rejectDialog.submitting = false
      this.rejectForm = {
        退回原因: '',
        备注: ''
      }
    },

    // ====== 驳回提交 ======
    handleRejectSubmit() {
      const row = this.checkDialog.rowData
      if (!row) return

      if (!this.rejectForm.退回原因 || this.rejectForm.退回原因.trim() === '') {
        this.$message.warning('请输入退回原因')
        return
      }

      this.$confirm(
        '确认驳回该付款计划吗？',
        '驳回确认',
        {
          type: 'warning',
          confirmButtonText: '确认驳回',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        this.rejectDialog.submitting = true
        this.checkDialog.submitting = true

        try {
          const params = {
            id: row.id,
            退回原因: this.rejectForm.退回原因.trim()
          }
          console.log('驳回参数===', params)

          const res = await sfPlanApi.reject(params)
          console.log('驳回返回===', res)

          if (res.code === 200) {
            this.$message.success('驳回成功！状态已更新为"待付"')
            this.rejectDialog.visible = false
            this.checkDialog.visible = false
            this.loadData()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('驳回失败:', error)
          this.$message.error(error.message || '操作失败，请稍后重试')
        } finally {
          this.rejectDialog.submitting = false
          this.checkDialog.submitting = false
        }
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    // ====== 打开房源详情弹窗 ======
    openHouseDetailDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }
      const row = this.selectedRows[0]
      if (!row.房源ID) {
        this.$message.warning('该记录没有关联的房源ID')
        return
      }
      this.houseDetailDialogVisible = true
    },

    // ====== 状态标签颜色 ======
    getStatusType(status) {
      const map = {
        '待付': 'danger',
        '已付': 'success',
        '已中止': 'info',
        '待审核': 'warning'
      }
      return map[status] || 'info'
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 时间戳格式化 ======
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ====== 刷新数据 ======
    refresh() {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.sf-plan-check-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;
}

.filter-section {
  background: #fff;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.filter-form {
  margin-bottom: 0;
}

.button-section {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.button-section .el-button {
  margin-bottom: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.pagination-section {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

/* ====== 审核弹窗 ====== */
.check-dialog /deep/ .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.check-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.check-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.check-dialog-content {
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 8px;
}

.check-dialog-content::-webkit-scrollbar {
  width: 6px;
}

.check-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.check-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.check-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.check-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

/* ====== 文件预览 ====== */
.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.file-group-inline {
  width: 100%;
}

.empty-tip-inline {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

/* ====== 房源详情弹窗 ====== */
.house-detail-dialog /deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.house-detail-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.house-detail-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

@media (max-width: 768px) {
  .sf-plan-check-container {
    padding: 10px;
  }

  .filter-form .el-form-item {
    display: block;
    margin-right: 0;
  }

  .button-section .el-button {
    margin-bottom: 8px;
  }

  .check-dialog-content {
    max-height: 40vh;
  }
}
/* ====== 付款凭证独立部分 ====== */
.file-section {
  margin-top: 16px;
  padding: 0 4px;
}

.file-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}
</style>